//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
  name: "Multiselect",
  components: {},
  inject: ["columnId"],
  props: ["value"],
  data: () => ({
    selectList: [],
    options: [],
    selected: [],
    comparison: null,
    comparisonList: [
      "equal",
      "not equal",
      "is null",
      "is not null",
      "in",
      "not in",
    ],
  }),
  methods: {
    filterSelection: function (name, update) {
      update(async () => {
        this.options = this.selectList.filter(
          (item) => item.name.toLowerCase().indexOf(name.toLowerCase()) >= 0
        );
      });
    },
  },
  computed: {
    tableColumnDataId() {
      return this.columnId();
    },
  },
};
